import { Component, Input } from '@angular/core';
import { DocumentNode } from '@completion/models';

@Component({
  selector: 'app-bullet-list',
  templateUrl: './bullet-list.component.html',
  styleUrls: ['./bullet-list.component.scss'],
  standalone: false,
})
export class BulletListComponent {
  @Input() nodes: DocumentNode[] = [];
  @Input() documentNode: DocumentNode;
  constructor() {}
}
